import React from "react";
import {
  Crown, Sparkles, Star, Trophy, Gem, Award, Rocket, Anchor, Medal,
  Flame, Shield, Gift, Diamond, Zap, Heart, Compass,
} from "lucide-react";

// Curated lucide set selectable in the admin Founders editor + rendered on cards.
export const FOUNDER_ICON_MAP = {
  Crown, Sparkles, Star, Trophy, Gem, Award, Rocket, Anchor, Medal,
  Flame, Shield, Gift, Diamond, Zap, Heart, Compass,
};

export const FOUNDER_ICON_NAMES = Object.keys(FOUNDER_ICON_MAP);

export function FounderIcon({ name, className = "" }) {
  const Cmp = FOUNDER_ICON_MAP[name] || Sparkles;
  return <Cmp className={className} />;
}
